import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import clsx from 'clsx'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import { hasLocizeTranslation } from 'lib/utils/locize'
import getProductPremiumType from 'components/shared/product/utils/ProductPremiumUtils'
import PRODUCT_PREMIUM_TYPE_ENUM from 'constants/product/product'
import useProductFlashSale from 'components/shared/product/hooks/useProductFlashSale/useProductFlashSale'
import styles from './product-banner.scss'

const ProductBanner = ({
  t,
  is_coming_soon,
  is_flash_sale,
  coming_soon_text,
  flash_sale_seconds_left,
}) => {
  const productBannerType = getProductPremiumType({
    isComingSoon: is_coming_soon,
    isFlashSale: is_flash_sale,
  })
  const { flashSaleTimeRemaining, isShowFlashSaleEnded } = useProductFlashSale(
    is_flash_sale,
    flash_sale_seconds_left,
  )

  const renderProductBanner = () => {
    switch (productBannerType) {
      case PRODUCT_PREMIUM_TYPE_ENUM.COMING_SOON:
        return (
          <div className="product-banner__coming-soon">
            <span className={Typo.overline}>{coming_soon_text}</span>
          </div>
        )
      case PRODUCT_PREMIUM_TYPE_ENUM.FLASH_SALE:
        return (
          <div className="product-banner__flash-sale">
            <span>
              <Icon
                src={ICONS.flashSale}
                size={ICON_SIZE.small}
                className="product-banner__flash-sale__icon"
              />
              <span className={clsx(Typo.button)}>
                {hasLocizeTranslation(t, 'FLASH_SALE', 'FLASH SALE')}
              </span>
            </span>
            {isShowFlashSaleEnded ? (
              <span className={clsx(Typo.button)}>
                {hasLocizeTranslation(t, 'ENDED', 'ENDED')}
              </span>
            ) : (
              <span>
                <span className={clsx(Typo.caption)}>
                  {hasLocizeTranslation(t, 'ENDING_IN', 'Ending in ')}
                </span>
                <span
                  className={clsx(
                    'product-banner__flash-sale__count-down',
                    Typo.button,
                  )}
                >
                  {flashSaleTimeRemaining}
                </span>
              </span>
            )}
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="product-banner">
      <style jsx>{styles}</style>
      {renderProductBanner()}
    </div>
  )
}

ProductBanner.defaultProps = {
  is_coming_soon: false,
  is_flash_sale: false,
  coming_soon_text: '',
  flash_sale_seconds_left: 0,
  internationalization: undefined,
}

ProductBanner.propTypes = {
  // component props
  t: PropTypes.func.isRequired,
  is_coming_soon: PropTypes.bool,
  is_flash_sale: PropTypes.bool,
  coming_soon_text: PropTypes.string,
  flash_sale_seconds_left: PropTypes.number,

  // redux props
  internationalization: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }),
}

export default compose(
  connect((state) => ({
    internationalization: state.internationalization,
  })),
  withI18next(),
)(ProductBanner)
